import { Button } from "@material-ui/core";
import i18next from 'i18next';

function Localization() {
  // function handleClick(lang) {
  //   i18next.changeLanguage(lang)
  // }
  const lan = localStorage.getItem("i18nextLng")
  function handleClick(lang) {
    if(lan === 'en' || lan === 'en-US'){
      i18next.changeLanguage('bn')
    }else{
      i18next.changeLanguage('en')
    }
  }

  return (
    <div >
        
        <Button style={{ marginTop: '5px', marginBottom: '5px' , marginRight: '5px', marginLeft: '5px'}} color="default" size="small" variant="contained" onClick={()=>handleClick('bn')} >
            {lan === 'bn' ? "English" : "Bangla"}
          </Button>
    </div>
  );
}

export default Localization;

export function formatNumberSeparatedByCommas(value) {
  return new Intl.NumberFormat('en-IN').format(value);

}

export function formatNumberInWords(num) {
  const a = [ '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
    'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen',
    'Seventeen', 'Eighteen', 'Nineteen' ];
  const b = [ '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety' ];

  const numToWords = (n, suffix) => {
    let str = '';
    if (n > 19) str += b[Math.floor(n / 10)] + ' ' + a[n % 10];
    else str += a[n];
    if (n) str += ' ' + suffix + ' ';
    return str;
  };

  if (isNaN(num)) return 'Invalid Number';

  let [intPart, decimalPart] = num.toString().split('.')
  let n = parseInt(intPart);

  if (n === 0) return 'Zero';

  let output = '';
  output += numToWords(Math.floor(n / 10000000), 'Crore');
  output += numToWords(Math.floor((n / 100000) % 100), 'Lakh');
  output += numToWords(Math.floor((n / 1000) % 100), 'Thousand');
  output += numToWords(Math.floor((n / 100) % 10), 'Hundred');

  if (n > 100 && n % 100) output += 'and ';
  output += numToWords(n % 100, '');

  if (decimalPart && parseInt(decimalPart)) {
    output += 'Taka and ';
    let paise = parseInt(decimalPart.padEnd(2, '0'));
    output += numToWords(paise, '') + 'Paisa Only';
  } else {
    output += 'Taka Only';
  }

  return output.replace(/ +/g, ' ').trim();
}